export default "__VITE_ASSET__BDGb$V6F__"